import React from 'react';
import styled from 'styled-components';
import { PrimaryButton, SecondaryButton } from 'styleguide/Buttons';
import { Modal, ModalTitle, zIndex } from 'styleguide/Modal';
import { FlexRow } from 'styleguide/Row';
import { Spacing } from 'styleguide/spacing';
import { P2 } from 'styleguide/Texts';
import { View } from 'styleguide/View';
import { t } from 'translations/t';

const Container = styled(View)`
  overflow: hidden;
  gap: ${Spacing.md}px;
`;

const UpperContainer = styled(View)`
  gap: ${Spacing.md}px;
`;

const LowerContainer = styled(FlexRow)`
  gap: ${Spacing.md}px;
  justify-content: flex-end;
`;

export interface ConfirmationModalProps {
  title: string;
  subtitle: string;
  submitButtonTitle: string;
  onConfirm: () => void;
  isOpen: boolean;
  onClose: () => void;
}

export const ConfirmationModal = ({
  title,
  subtitle,
  submitButtonTitle,
  onConfirm,
  isOpen,
  onClose,
}: ConfirmationModalProps) => {
  return (
    <Modal
      onClose={onClose}
      overlayStyle={{ zIndex: zIndex.modalOverlay }}
      isOpen={isOpen}
      contentStyle={{ padding: Spacing.lg }}
    >
      <Container>
        <UpperContainer>
          <ModalTitle title={title} onClose={onClose} />
          <P2 type="secondary">{subtitle}</P2>
        </UpperContainer>
        <LowerContainer>
          <SecondaryButton title={t('global.cancel')} onClick={onClose} />
          <PrimaryButton title={submitButtonTitle} onClick={onConfirm} />
        </LowerContainer>
      </Container>
    </Modal>
  );
};
